import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/workouts-new/workouts.css";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import CommonStructured from "../../components/common-components/CommonStructured";
import CommonFilterStructure from "../../components/common-components/CommonFilterStructure";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import AllExercises from "../../components/workouts-new/exercise/AllExercises";
import ExerciseCards from "../../components/workouts-new/exercise/ExerciseCards";
import {
  fetchWorkoutExerciseData,
  fetchWorkoutExerciseStatsData,
} from "../../redux/workout-reducers/workoutApis";

const WorkoutsExercise = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { loading, statsLoading, exerciseStats, exerciseData } = useSelector(
    (state) => state.workoutApi
  );

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    viewVideo: "",
    viewImage: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    filterType: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    category_id:
      allFilters.filterType?.toLowerCase() === "total"
        ? ""
        : allFilters.filterType,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  function getWorkoutExerciseStats(filters = {}) {
    dispatch(
      fetchWorkoutExerciseStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getWorkoutExercise(filters) {
    dispatch(
      fetchWorkoutExerciseData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getWorkoutExerciseStats();
  }, []);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      category_id:
        allFilters.filterType?.toLowerCase() === "total"
          ? ""
          : allFilters.filterType,
    }));
  }, [allFilters.filterType, isPage]);

  useEffect(() => {
    getWorkoutExercise(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Workout Exercise">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            {statsLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <ExerciseCards
                exerciseStats={exerciseStats}
                setCardValues={setAllFilters}
                setIsPage={setIsPage}
              />
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"All Exercises"}
              createBtnTxt={"+ Add Exercise"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from={"only-search"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <AllExercises
              tbDatas={exerciseData}
              isPage={isPage}
              setIsPage={setIsPage}
              callFunction={() => {
                getWorkoutExerciseStats(filters);
                getWorkoutExercise(filters);
              }}
              userInfoData={userInfoData}
              modValues={modValues}
              setModValues={setModValues}
              onCloseModalvalues={onCloseModalvalues}
              isAllExerciseLoading={loading}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default WorkoutsExercise;
